import { useState } from "react";
import AppIconButtonSecondary from "../../AppButtons/AppIconButtonSecondary";
import AppIconsDots from "../../AppIcons/AppIconsDots";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  MenuItem,
  Typography,
} from "@mui/material";
import { useReduxState } from "../../../../explorer/redux/hooks";
import { Basket } from "../../../../explorer/types";
import { reduxStoreConfig } from "../../../configuration/reduxStoreConfig";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { AppIconsClose, AppIconsPushpin } from "../../AppIcons";
import {
  DialogContentStyled,
  DialogTitleStyled,
} from "./DrawerPartDetails.styles";
import { formatDateByLocale } from "../../../../explorer/helpers/CommonHelper";
import useLanguages from "../../../../explorer/hooks/useLanguages";

type TDrawerPartDetailsBaskets = {
  setSelectedBasket: React.Dispatch<React.SetStateAction<Basket>>;
};

const DrawerPartDetailsBaskets = (props: TDrawerPartDetailsBaskets) => {
  const [basketsList] = useReduxState<Basket[]>(reduxStoreConfig.basketBaskets);
  const [open, setOpen] = useState(false);
  const lang = useLanguages().currentLanguage;
  const { t } = useTranslation();

  const handleChange = (basket: Basket) => {
    props.setSelectedBasket(basket);
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box>
      <AppIconButtonSecondary
        sx={{ width: 28, height: 28 }}
        aria-haspopup="true"
        onClick={handleOpen}
      >
        <AppIconsDots sx={{ fontSize: 20 + "px !important" }} />
      </AppIconButtonSecondary>

      <Dialog
        id="dialog-basket"
        aria-labelledby="dialog-title"
        open={open}
        onClose={handleClose}
      >
        <DialogTitleStyled>
          <div>{t("common.spareparts.selectBasket")}</div>
          <IconButton onClick={handleClose}>
            <AppIconsClose />
          </IconButton>
        </DialogTitleStyled>
        <DialogContentStyled>
          <List>
            {basketsList.map((basket: Basket) => (
              <MenuItem key={basket.id} onClick={() => handleChange(basket)}>
                <Box>
                  <Typography fontSize="0.70rem" display="block" variant="caption">
                    {basket.creationDate && (
                      <>{formatDateByLocale(basket.creationDate, lang)}</>
                    )}
                  </Typography>
                  <Typography fontSize="inherit" display="block">{basket.name}</Typography>
                </Box>
              </MenuItem>
            ))}
          </List>
        </DialogContentStyled>
      </Dialog>
    </Box>
  );
};

export default DrawerPartDetailsBaskets;
